import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Typography,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { gatAdminFaqByUserType } from "../../services/adminSettingsFn";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { appImages } from "../../assets";
import NavBar from "../../components/NavBar";
import AppFooter from "../../components/footer";
import AppLoader from "../../components/apploader";
import { t } from "i18next";
import { useSelector } from "react-redux";

const Faqs = () => {
  const [allFaqs, setAllFaqs] = useState([]);
  const [expanded, setExpanded] = React.useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { showSnackbar } = useSnackbar();
  
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  console.log(currentLanguage, "HELLOG");

  useEffect(() => {
    getAllFaqs();
  }, [currentLanguage]);

  const getAllFaqs = async () => {
    try {
      setIsLoading(true);
      const type = window.location.pathname.split("/").pop();
      let responseee = await gatAdminFaqByUserType(type, currentLanguage);
      if (responseee.status == 200 || responseee.status == 201) {
        setAllFaqs(responseee.data.data);
      } else {
        showSnackbar(responseee.data.message, "error");
      }
    } catch (error) {
      showSnackbar("Network Error", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <Box>
        <NavBar />
      </Box>
      <Box
        marginTop={8}
        height={"100vh"}
        display={"flex"}
        flexDirection={"column"}
        position={"relative"}
        sx={{
          backgroundImage: `url(https://service-provider-2024.s3.us-east-1.amazonaws.com/uploads/1744141495520_faq-bg.jpg)`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Container sx={{ maxWidth: "900px !important", marginTop: "90px" }}>
          <Typography
            variant="heading_pr"
            fontSize={{ xs: "1.5rem", sm: "2.5rem" }}
            component={"h1"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
            textTransform={"capitalize"}
          >
            {t("faqs")}
          </Typography>
          <Typography
            variant="heading_pr"
            fontSize={{ xs: "1.5rem", sm: "2rem" }}
            component={"h1"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
          >
            {t("youNeedToKnowAbout")}{" "}
            {t(window.location.pathname.split("/").pop())}.
          </Typography>
          <Stack spacing={2} mt={3}>
            {allFaqs?.length > 0 ? (
              allFaqs?.map((itemmm) => {
                return (
                  <Accordion
                    key={itemmm.name}
                    expanded={expanded === itemmm._id}
                    onChange={handleChange(itemmm._id)}
                    sx={{
                      border: "none",
                      boxShadow: "none",
                      padding: "0px 10px",
                      marginBottom: "25px",
                      "&:before": {
                        background: "none",
                      },
                    }}
                  >
                    {/* expanded == itemmm._id */}
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{
                        fontWeight: "500",
                        fontSize: { xs: "16px", sm: "24px" },
                        color: "#303030",
                        padding: 0,
                      }}
                    >
                      {itemmm.question}
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{
                        fontWeight: "400",
                        fontSize: { xs: "14px", sm: "20px" },
                        color: "#687378",
                        lineHeight: "30px",
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: itemmm.answer,
                        }}
                      />
                    </AccordionDetails>
                  </Accordion>
                );
              })
            ) : (
              <Box
                sx={{
                  width: "100%",
                  textAlign: "center",
                  marginTop: "12px",
                }}
              >
                <Typography
                  sx={{
                    color: "#303030",
                    fontWeight: "700",
                    fontSize: "18px",
                    color: "text.white",
                  }}
                >
                  {isLoading ? "Fetching data, Please wait!" : "No Faqs Found!"}
                </Typography>
              </Box>
            )}
          </Stack>
        </Container>

        <img
          src={appImages.helpPageWaveImg}
          width={"100%"}
          style={{
            position: "absolute",
            bottom: 0,
          }}
        />
      </Box>
      <AppFooter bgcolor={true} />
    </>
  );
};

export default Faqs;
